import { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useCurrentUser() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/auth/me`, { credentials: 'include' });
        if (alive && res.ok) setUser(await res.json());
      } catch (e) { /* ignore */ }
    })();
    return () => { alive = false; };
  }, []);
  return user;
}
